// extracted by mini-css-extract-plugin
export default {"StatContainer":"Statistics_StatContainer__czfjF","Tabs":"Statistics_Tabs__YKdTc","SelectedTab":"Statistics_SelectedTab__msz+x"};